import { changeLocaleAndUpdate, setTargetHost } from './i18n';
export class I18nEmbeddedManager {
    constructor(localeCode, container) {
        this.localeCode = localeCode;
        setTargetHost(container);
    }
    async init() {
        await changeLocaleAndUpdate(this.localeCode);
    }
    async changeLocale(localeCode) {
        return await changeLocaleAndUpdate(localeCode);
    }
}
//# sourceMappingURL=i18n-embedded-controller.js.map